export enum CheckboxState {
	Checked = 'checked',
	Unchecked = 'unchecked',
	Indeterminate = 'indeterminate',
	ImplicitlyChecked = 'implicitlyChecked',
}

export type CheckboxTreeNodeType = {
	value: string;
	label: string;
	state: CheckboxState;
	children?: CheckboxTreeNodeType[];
};
